import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import ar from './locales/ar/translation.json';
import vi from './locales/vi/translation.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  ar: { translation: ar },
  vi: { translation: vi },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'ar', 'vi'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'language',
    },
  });

export default i18n;
